import { KonstantionAuthHttps } from '../../fetchUrls'
import google from './img/google.svg'
import yandex from './img/yandex.svg'
import './ExternalAuthentication.scss'



const ExternalAuthentication = () => {
    // Для рефералов
    const urlParams = new URLSearchParams(window.location.search);
    const referrer_token = urlParams.get('utm_ref');

    const handlerGoogle = (e) => {
        let url = `${KonstantionAuthHttps}/oauth/google/authorize`

        const body = JSON.stringify({
            device_info: window.navigator.userAgent,
            referrer_token: referrer_token || undefined
        })

        const headers = { 'Content-Type': 'application/json' }

        fetch(url, { body, method: 'POST', headers })
            .then(res => res.json())
            .then(json => {
                const url = Object.values(json).join('')
                window.location.assign(url)
            })
            .catch(err => console.error(err))
    }

    const handlerYandex = (e) => {
        let url = `${KonstantionAuthHttps}/oauth/yandex/authorize`

        const body = JSON.stringify({
            device_info: window.navigator.userAgent,
            referrer_token: referrer_token || undefined
        })

        const headers = { 'Content-Type': 'application/json' }

        fetch(url, { body, method: 'POST', headers })
            .then(res => res.json())
            .then(json => {
                const url = Object.values(json).join('')
                window.location.assign(url)
            })
            .catch(err => console.error(err))
    }

    return (
        <div className='btn-group__social-media'>
            {/* <div className='btn__social-media' onClick={() => handlerGoogle()}>
                <object className='btn__social-media-img' type='image/svg+xml' data={google} />
                <p className='text'>Google</p>
            </div> */}

            <div className='btn__social-media' onClick={() => handlerYandex()}>
                <object className='btn__social-media-img' type='image/svg+xml' data={yandex} />
                <p className='text'>Яндекс</p>
            </div>
        </div>
    )
}

export default ExternalAuthentication